var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "debt-fields" }, [
    _c(
      "div",
      [
        _vm._m(0),
        _c("BaseInput", {
          attrs: {
            id: "long-term-debt-balance",
            value: _vm.inputs.longTermDebt,
            type: "number",
            "format-type": "currencyNumber",
            placeholder: "Monto",
            icon: "a-solid fa-dollar-sign",
          },
          on: { input: (value) => _vm.updateInputs(value, "longTermDebt") },
        }),
      ],
      1
    ),
    _c(
      "div",
      [
        _vm._m(1),
        _c("BaseInput", {
          attrs: {
            id: "short-term-debt-balance",
            value: _vm.value.shortTermDebt,
            type: "number",
            "format-type": "currencyNumber",
            placeholder: "Monto",
            icon: "a-solid fa-dollar-sign",
          },
          on: { input: (value) => _vm.updateInputs(value, "shortTermDebt") },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "debt-field" },
      [
        _c("div", { staticClass: "inputs-title" }, [
          _c(
            "span",
            { staticClass: "title-text is-size-6 has-text-weight-semibold" },
            [_vm._v("Agregar Deuda Acreditada")]
          ),
          _c(
            "a",
            {
              attrs: { id: "add-debt-button", href: "#" },
              on: {
                click: function ($event) {
                  return _vm.$emit("add-input", {
                    debtorIndex: _vm.debtorIndex,
                    type: "debt",
                    gloss: "accreditedDebts",
                  })
                },
              },
            },
            [_c("span", { staticClass: "fa fa-plus-circle" })]
          ),
        ]),
        _vm._l(_vm.inputs.accreditedDebts, function (accreditedDebt, i) {
          return _c("div", { key: i, staticClass: "gloss-value" }, [
            _c(
              "a",
              {
                attrs: { id: `debt-${i}-delete-button`, href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("delete-input", {
                      debtorIndex: _vm.debtorIndex,
                      type: "debt",
                      gloss: "accreditedDebts",
                      inputIndex: i,
                    })
                  },
                },
              },
              [_c("i", { staticClass: "fa-solid fa-trash-can" })]
            ),
            _c(
              "div",
              { staticClass: "b-field-inputs" },
              _vm._l(_vm.accreditedDebtsFields, function (field, fieldName) {
                return _c(
                  "div",
                  { key: fieldName, staticClass: "b-field-input" },
                  [
                    _c("BaseInput", {
                      attrs: {
                        id: `debt-${i}-${fieldName}`,
                        value: _vm.value.accreditedDebts[i][fieldName],
                        title: field.title,
                        "term-type": _vm.inputs.accreditedDebts[i].termType,
                        "self-term-type": field.selfTermType,
                        type: field.type,
                        "format-type": field.formatType,
                        placeholder: field.placeholder,
                        options: field.options,
                        icon: field.icon,
                      },
                      on: {
                        input: (value) =>
                          _vm.updateInputs(
                            value,
                            "accreditedDebts",
                            i,
                            fieldName
                          ),
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inputs-title-text" }, [
      _c(
        "span",
        { staticClass: "title-text is-size-6 has-text-weight-semibold" },
        [_vm._v("Deuda Largo plazo")]
      ),
      _c("span", { staticClass: "title-comment is-size-7" }, [
        _vm._v("según SBIF"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inputs-title-text" }, [
      _c(
        "span",
        { staticClass: "title-text is-size-6 has-text-weight-semibold" },
        [_vm._v("Deuda Corto plazo")]
      ),
      _c("span", { staticClass: "title-comment is-size-7" }, [
        _vm._v("según SBIF"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }